import { IModule, ModuleContent, ModuleParams } from '../types';
import { PdfFont, PdfBrush, PdfSize, ETextAlign, PdfRect, PageGen } from '../../pdf/pdf';

export const textModule: IModule = {
  name: 'text',

  parse(source: string, attrs: Record<string, string>): ModuleContent {
    return { type: 'text', attrs, content: source };
  },

  measure(content: ModuleContent, params: ModuleParams): PdfSize {
    const font = params.font || new PdfFont(PdfFont.FONT_NAME, 12);
    const page = params.page!;
    const text = content.content;

    if (!page) {
      return new PdfSize(text.length * font.size * 0.6, font.size * 1.2);
    }

    const width = page.pdf.getFont(font.font).widthOfTextAtSize(text, font.size);
    const height = font.size * 1.2;
    return new PdfSize(width, height);
  },

  draw(content: ModuleContent, rect: PdfRect, align: ETextAlign, params: ModuleParams): void {
    const font = params.font || new PdfFont(PdfFont.FONT_NAME, 12);
    const brush = params.brush || PdfBrush.Black;
    const page = params.page!;

    if (!page) {
      throw new Error('PageGen required for drawing');
    }

    page.drawString(content.content, font, brush, null, rect, align);
  },
};
